module.exports = __webpack_public_path__ + "img/29.1706d8e7.png";